import create from 'zustand';

import { StorageE } from 'declarations/enums/storage';

type UseAuthStoreT = {
  isUserLoggedIn: boolean;
  setUserLoginStatus: (isUserLoggedIn: boolean) => void;
};

const hasToken = !!localStorage.getItem(StorageE.IdToken);

const useAuthStore = create<UseAuthStoreT>(
  (set): UseAuthStoreT => ({
    isUserLoggedIn: hasToken,
    setUserLoginStatus: (isUserLoggedIn: boolean): void => set({ isUserLoggedIn }),
  })
);

export default useAuthStore;
